import { render, staticRenderFns } from "./districhat.vue?vue&type=template&id=5781ab18&scoped=true&"
import script from "./districhat.vue?vue&type=script&lang=js&"
export * from "./districhat.vue?vue&type=script&lang=js&"
import style0 from "./districhat.vue?vue&type=style&index=0&id=5781ab18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781ab18",
  null
  
)

export default component.exports